import { render, staticRenderFns } from "./CallUiCategories.vue?vue&type=template&id=41444025&scoped=true"
import script from "./CallUiCategories.vue?vue&type=script&lang=js"
export * from "./CallUiCategories.vue?vue&type=script&lang=js"
import style0 from "./CallUiCategories.vue?vue&type=style&index=0&id=41444025&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41444025",
  null
  
)

export default component.exports